import { PxApiError } from './PxApiError';
import { Result } from '../InternalTypes';

export function ensureError(value: unknown): Error {
	if (value instanceof Error) {
		return value;
	}

	let stringified = '[Unable to stringify the thrown value]';
	try {
		stringified = JSON.stringify(value);
	} catch {
		/* istanbul ignore next */
		return new PxApiError(stringified);
	}

	return new PxApiError(`This value was thrown as is, not through an Error: ${stringified}`);
}

export function isError<T, E extends PxApiError>(resultObj: Result<T, E>): resultObj is { success: false; error: E } {
	return resultObj.success === false;
}
